var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundcloudMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 256,
    viewBox: "0 0 512 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-soundcloud-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 256
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "soundcloud-mask",
    clipPath: "url(#clip-soundcloud-mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 512,
    height: 218,
    rx: 100,
    transform: "translate(0 19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(190 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M0,0V76.174",
    transform: "translate(43.5 101.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M0,0V45.861",
    transform: "translate(13.5 131.813)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M0,0V119.54",
    transform: "translate(135.53 57.729)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M0,0V76.174",
    transform: "translate(73.5 101.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M0,0V106.407",
    transform: "translate(103.5 71.267)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(173 110)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_13",
    "data-name": "Subtraction 13",
    d: "M3599.447,8890c-1.819,0-3.651-.082-5.446-.245v-134.51c1.805-.162,3.637-.244,5.446-.244a59.968,59.968,0,0,1,24.738,5.3,62.4,62.4,0,0,1,10.8,6.224,65.036,65.036,0,0,1,9.406,8.241,67.36,67.36,0,0,1,7.76,9.989,68.912,68.912,0,0,1,5.86,11.467,71.6,71.6,0,0,1,0,52.547,68.875,68.875,0,0,1-5.86,11.467,67.338,67.338,0,0,1-7.76,9.99,65.025,65.025,0,0,1-9.406,8.241,62.4,62.4,0,0,1-10.8,6.224A59.968,59.968,0,0,1,3599.447,8890Z",
    transform: "translate(-3459 -8705)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 71,
    height: 30,
    transform: "translate(140 155)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloudMask);
export default __webpack_public_path__ + "static/media/soundcloud-mask.296d38d9.svg";
export { ForwardRef as ReactComponent };